export default __webpack_public_path__ + "static/media/security.24710057.svg";